import {
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';
import { calculationStatusForTable } from '../Subscriptions/slice';

export const columns = [
  {
    id: 1,
    Header: 'ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 2,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      return cell.value.id;
    }
  },

  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell.value.name} {cell.value.surname}
        </>
      );
    }
  },
  {
    id: 4,
    Header: 'Product Name',
    accessor: 'productName',
    Cell: (cell: any) => {
      return cell.value;
    }
  },
  {
    id: 5,
    Header: 'Price',
    accessor: 'package',
    Cell: (cell: any) => {
      return cell.row.original.price
        ? usdFormatter.format(cell.row.original.price)
        : '---';
    }
  },

  {
    id: 6,
    Header: 'Price + VAT + FEE',
    accessor: 'price',
    Cell: (cell: any) => {
      return cell?.row?.original?.orderPayments[0]?.amount
        ? usdFormatter.format(cell?.row?.original?.orderPayments[0]?.amount)
        : '---';
    }
  },

  {
    id: 7,
    Header: 'Order Date',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell.row.original.dateCreated)},
        <small className='text-muted'>
          {' '}
          {handleValidTime(cell.row.original.dateCreated)}
        </small>
      </>
    )
  },

  {
    id: 8,
    Header: 'Payment Date',
    accessor: 'datePaid',
    Cell: (cell: any) => {
      if (cell.value) {
        return (
          <>
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        );
      }
    }
  },
  {
    id: 9,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell.value) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              PENDING
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              {calculationStatusForTable(cell.row.original.calculationStatus)}
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED BY USER
            </span>
          );
      }
    }
  }
];
